<template>
    <div :class="wrapperClass"
        @click="onClick"
    >
        <div v-if="isVideo"
            class="video-container"
        >
            <video ref="videoPlayer"
                :src="url"
                autoplay
                loop
                :muted="isMuted"
                :class="['nft__image', {'nft__image--no-background': !hasBackground}]"
            />
            <a class="toggle-mute"
                @click="toggleMute"
            >
                <img v-if="!isMuted"
                    :src="require(`@webapp/assets/unmuted.svg`)"
                >
                <img v-if="isMuted"
                    :src="require(`@webapp/assets/muted.svg`)"
                >
            </a>
        </div>

        <template v-else>
            <img v-if="url"
                :src="url"
                alt="NFT image"
                :class="['nft__image', {'nft__image--no-background': !hasBackground}]"
            >
        </template>
    </div>
</template>

<script>
export default {
    name: 'nft-display',
    props: {
        url: {
            type: String,
            default: '',
        },
        hasBackground: {
            type: Boolean,
            default: true,
        },
        onClick: {
            type: Function,
            default: () => false,
        },
        isVideo: {
            type: Boolean,
            default: false,
        },
        muted: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isMuted: this.muted,
        };
    },
    computed: {

        wrapperClass() {
            return [
                'nft', {
                    'nft--has-logo': this.url,
                },
            ];
        },
    },
    methods: {
        toggleMute() {
            this.isMuted = !this.isMuted;
        },
    },
};
</script>

<style lang="scss" scoped>
.nft {
    background-color: $dusty-gray-color;
    z-index: 1;
    align-self: flex-end;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: right;

    &--has-logo {
        background-color: initial;
    }

    &__image {
        width: 100%;
        height: 100%;
        transform: translate3d(0, 0, 0.1rem);
        // Secure elongated logos fit in the container
        object-fit: contain;
        z-index: 2;

        &--no-background {
            background: unset;
        }
    }
}

.video-container {
    position: relative;
    z-index: 1;

    .toggle-mute {
        position: absolute;
        right: 2rem;
        bottom: 2rem;
    }
}
</style>